/* Murmures d'Iqra - Accessibilite JS (i18n) */
(function(){
var KEY='iqra_a11y_prefs';
var fl=0;
var st={hc:0,spacing:0,links:0,anim:0,cursor:0,cb:0,dys:0};
var S=window.iqraA11yStrings||{panelOpen:'Panneau ouvert',panelClosed:'Panneau ferme',fontNormal:'Taille normale',font1:'Texte agrandi',font2:'Texte plus grand',font3:'Texte tres grand',contrastOn:'Contraste eleve',contrastOff:'Normal',spacingOn:'Espacement accru',spacingOff:'Normal',linksOn:'Liens soulignees',linksOff:'Normal',animOn:'Pause',animOff:'Actif',cursorOn:'Grand curseur',cursorOff:'Normal',cbOn:'Mode daltonien active',cbOff:'Mode daltonien desactive',dysOn:'Police dyslexie activee',dysOff:'Police dyslexie desactivee',reset:'Reinitialise'};
function load(){try{var r=localStorage.getItem(KEY);if(!r)return;var p=JSON.parse(r);fl=p.fl||0;Object.keys(st).forEach(function(k){if(p[k])st[k]=p[k];});}catch(e){}}
function save(){try{var o={fl:fl};Object.keys(st).forEach(function(k){o[k]=st[k];});localStorage.setItem(KEY,JSON.stringify(o));}catch(e){}}
function say(msg,a){var id=a?'iqra-a11y-alert':'iqra-a11y-announce';var el=document.getElementById(id);if(!el)return;el.textContent='';setTimeout(function(){el.textContent=msg;},50);}
window.iqraAnnounce=say;
function applyFont(){document.body.classList.remove('iqra-font-1','iqra-font-2','iqra-font-3');if(fl>0)document.body.classList.add('iqra-font-'+Math.min(fl,3));}
function applyKey(k,v){document.body.classList.toggle('iqra-'+k,!!v);var b=document.getElementById('iqra-a11y-btn-'+k);if(b)b.setAttribute('aria-pressed',v?'true':'false');}
function applyAll(){applyFont();Object.keys(st).forEach(function(k){applyKey(k,st[k]);});}
window.iqraA11yToggleBar=function(){
  var p=document.getElementById('iqra-a11y-panel');
  var t=document.getElementById('iqra-a11y-trigger');
  if(!p||!t)return;
  if(p.hasAttribute('hidden')){p.removeAttribute('hidden');t.setAttribute('aria-expanded','true');var f=p.querySelector('button');if(f)f.focus();say(S.panelOpen);}
  else{p.setAttribute('hidden','');t.setAttribute('aria-expanded','false');t.focus();say(S.panelClosed);}
};
window.iqraA11yFontSize=function(d){
  if(d===0){fl=0;}else{fl=Math.max(0,Math.min(3,fl+d));}
  applyFont();save();
  var msgs=[S.fontNormal,S.font1,S.font2,S.font3];
  say(msgs[fl]);
};
window.iqraA11yToggle=function(k){
  st[k]=st[k]?0:1;applyKey(k,st[k]);save();
  var onMap={hc:S.contrastOn,spacing:S.spacingOn,links:S.linksOn,anim:S.animOn,cursor:S.cursorOn,cb:S.cbOn,dys:S.dysOn};
  var offMap={hc:S.contrastOff,spacing:S.spacingOff,links:S.linksOff,anim:S.animOff,cursor:S.cursorOff,cb:S.cbOff,dys:S.dysOff};
  say(st[k]?(onMap[k]||''):(offMap[k]||''));
};
window.iqraA11yReset=function(){
  fl=0;Object.keys(st).forEach(function(k){st[k]=0;});
  applyAll();try{localStorage.removeItem(KEY);}catch(e){}say(S.reset);
};
window.iqraFocusTrap=function(c,ret){
  var sel='a[href],button:not([disabled]),input:not([disabled]),select,textarea';
  var els=c.querySelectorAll(sel);
  if(!els.length)return;
  var first=els[0],last=els[els.length-1];
  first.focus();
  function trap(e){if(e.key!=='Tab')return;if(e.shiftKey){if(document.activeElement===first){e.preventDefault();last.focus();}}else{if(document.activeElement===last){e.preventDefault();first.focus();}}}
  function rel(e){if(e.key==='Escape'){c.removeEventListener('keydown',trap);document.removeEventListener('keydown',rel);if(ret)ret.focus();}}
  c.addEventListener('keydown',trap);
  document.addEventListener('keydown',rel);
};
document.addEventListener('keydown',function(e){
  if(e.key==='Tab')document.body.classList.add('iqra-keyboard-nav');
  if(e.key==='Escape'){var p=document.getElementById('iqra-a11y-panel');var t=document.getElementById('iqra-a11y-trigger');if(p&&!p.hasAttribute('hidden')){p.setAttribute('hidden','');if(t){t.setAttribute('aria-expanded','false');t.focus();}}}
});
document.addEventListener('mousedown',function(){document.body.classList.remove('iqra-keyboard-nav');});
document.addEventListener('iqra:cart:added',function(){
  setTimeout(function(){
    var c=document.querySelector('.cart-count,[data-cart-count]');
    if(c){var n=parseInt(c.textContent.trim(),10);if(!isNaN(n)){var msg=n+' article'+(n>1?'s':'')+' dans le panier';say(msg);c.setAttribute('aria-label',msg);}}
    var d=document.getElementById('cart-drawer');
    if(d&&!d.hasAttribute('hidden'))window.iqraFocusTrap(d,document.activeElement);
  },400);
});
function enrichPage(){
  var m=document.getElementById('MainContent');
  if(m){if(!m.getAttribute('tabindex'))m.setAttribute('tabindex','-1');if(!m.getAttribute('role'))m.setAttribute('role','main');}
  var f=document.querySelector('footer');
  if(f&&!f.id)f.id='iqra-footer-start';
  document.querySelectorAll('img').forEach(function(img){
    if(img.alt&&img.alt.trim())return;
    var ar=img.closest('article');
    if(ar){var h=ar.querySelector('h1,h2,h3');if(h){img.setAttribute('alt',h.textContent.trim());return;}}
    var ca=img.closest('.miq-na-card,.iqra-ap-card');
    if(ca){var tt=ca.querySelector('h3,h4,.miq-na-card-title');if(tt){img.setAttribute('alt',tt.textContent.trim());return;}}
    img.setAttribute('alt','Murmures d Iqra');
  });
}
load();
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){applyAll();enrichPage();});}
else{applyAll();enrichPage();}
})();
